export default __webpack_public_path__ + "263105879018adab5986d1d9e96a1ff6.png";